import { render, staticRenderFns } from "./Geetest.vue?vue&type=template&id=80df4bce&scoped=true&"
import script from "./Geetest.vue?vue&type=script&lang=js&"
export * from "./Geetest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80df4bce",
  null
  
)

export default component.exports